import { Link } from 'react-router-dom';
import {
  footerMeta,
  legalFooterLinks,
  primaryNavLinks,
  siteBrandName,
} from '../../content/navigation';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-surface border-t border-border">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-7 h-7 bg-primary rounded-md flex items-center justify-center">
                <span className="text-white text-xs font-bold">C</span>
              </div>
              <span className="text-lg font-bold text-primary">{siteBrandName}</span>
            </div>
            <p className="text-sm text-textMuted leading-relaxed max-w-xs">
              AIとのチャットでLPの作成・修正・公開ができるサービスです。
            </p>
            <p className="text-sm text-textMuted/60 mt-4">運営：{footerMeta.operatorName}</p>
          </div>

          {/* Nav */}
          <div>
            <p className="text-xs font-semibold tracking-widest text-textMuted/50 uppercase mb-4">プロダクト</p>
            <div className="flex flex-col gap-2.5">
              {primaryNavLinks.map((item) => (
                <Link key={item.to} to={item.to} className="text-sm text-textMuted hover:text-primary transition-colors">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs font-semibold tracking-widest text-textMuted/50 uppercase mb-4">法務・サポート</p>
            <div className="flex flex-col gap-2.5">
              {legalFooterLinks.map((item) => (
                <Link key={item.label} to={item.href} className="text-sm text-textMuted hover:text-primary transition-colors">
                  {item.label}
                </Link>
              ))}
              <Link to={footerMeta.contactTo} className="text-sm text-textMuted hover:text-primary transition-colors">
                お問い合わせ
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-textMuted/50">&copy; {year} {footerMeta.copyrightName}. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/auth/sign-in" className="text-xs text-textMuted/60 hover:text-primary transition-colors">ログイン</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
